import { createContext, useContext } from 'react';
import { getContrastRatio } from '@mui/material/styles';
import { useColorScheme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { DEFAULT_BRAND, getBrand } from '.';

// Preenchido pelo AppThemeProvider; o valor padrão cobre testes sem provider.
export const BrandContext = createContext(getBrand(DEFAULT_BRAND));

// Dados da marca que não cabem no tema do MUI (nome e logo): a ativa ou, com
// `brandKey`, uma marca fixa (ex.: login sempre Beworks).
// - `logo`: acompanha o esquema de cor; sem versão para o dark, vale a do light.
// - `logoOnDark`: para superfícies escuras em qualquer esquema (ex.: AppBar em
//   `primary`); sem versão para o dark, vale a do light.
// - `dashboardAppBarLogo`: o da AppBar do dashboard, escolhido pelo fundo dela.
export default function useBrand(brandKey) {
  const activeBrand = useContext(BrandContext);
  const { name, logo } = brandKey ? getBrand(brandKey) : activeBrand;
  const { colorScheme } = useColorScheme();
  const theme = useTheme();
  const logoOnDark = logo.dark || logo.light;
  return {
    name,
    logo: colorScheme === 'dark' ? logoOnDark : logo.light,
    logoOnDark,
    dashboardAppBarLogo: isDashboardAppBarDark(theme, colorScheme) ? logoOnDark : logo.light,
  };
}

// No dark a AppBar ignora a cor e usa `AppBar.darkBg` (sem `enableColorOnDark`):
// é sempre escura. No light vale a regra do MUI para o contrastText: o fundo é
// escuro quando o branco tem contraste suficiente sobre ele. Lê o valor
// resolvido do esquema (`theme.palette` com CSS vars devolveria só o do light).
function isDashboardAppBarDark(theme, colorScheme) {
  if (colorScheme === 'dark') return true;
  const background = theme.colorSchemes?.light?.palette.dashboardAppBar?.main;
  if (!background) return true;
  return getContrastRatio(background, '#fff') >= theme.palette.contrastThreshold;
}
